import {useEffect, useState} from "react";
import {Breadcrumb, ConfigProvider, Input, Layout, Menu} from "antd";
import Main from "./components/Main";
import ScreenSwitcher from "./components/views/ScreenSwitcher";
import './App.less';
import Login from "./components/Login";
import SystemFunctions from "./helpers/SystemFunctions";
import Server from "./helpers/Server";

let storageUid = SystemFunctions.getStorage('user_id');
let storageSid = SystemFunctions.getStorage('session_id');
let storageToken = SystemFunctions.getStorage('session_token');
if (storageUid != null){
    Server.user_id = storageUid;
}
if (storageSid != null){
    Server.session_id = storageSid;
    Server.session_token = storageToken;
}

let savedTheme = SystemFunctions.getStorage('theme');
let DEFAULT_THEME = savedTheme == null ? 'light' : savedTheme; // light | dark

const updateThemeBody = (theme) => {
    const schemeAttribute = document.createAttribute('theme');
    schemeAttribute.value = theme;
    document.body.attributes.setNamedItem(schemeAttribute);
}
updateThemeBody(DEFAULT_THEME);

function App() {
    const [screen, setScreen] = useState(Server.session_id > 0 ? 'main' : 'login');
    const [theme, setTheme] = useState(DEFAULT_THEME);

    const setThemeWrapper = (theme) => {
        setTheme(theme);
        updateThemeBody(theme);
        SystemFunctions.saveStorage('theme', theme);
    }
    window.st = () => {
        setThemeWrapper(theme == 'dark' ? 'light' : 'dark');
    }
    window.logout = () => {
        SystemFunctions.removeStorage('user_id');
        SystemFunctions.removeStorage('session_id');
        SystemFunctions.removeStorage('session_token');
        setScreen('login');
    }

    return (
        <ConfigProvider>
            <div className={`AppRoot theme-${theme}`}>
                <ScreenSwitcher screen={screen}>
                    <Main key='main' go={setScreen} theme={theme} setTheme={setThemeWrapper}/>
                    <Login key='login' go={setScreen} theme={theme} setTheme={setThemeWrapper}/>
                </ScreenSwitcher>
            </div>
        </ConfigProvider>

    );
}

export default App;